export default __webpack_public_path__ + "static/media/Merge3.9099f454.png";